import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { ICustomsTask } from '../interfaces';
import { CustomsTasksMapper } from '../mappers';

export type IGetCustomsTasksRepoResponse = IRepoResponse<200, { data: ICustomsTask[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetCustomsTasksRepo = IRepo<[any], IGetCustomsTasksRepoResponse>;

export const GetCustomsTasksRepoType = Symbol.for('GetCustomsTasksRepo');

@bind(GetCustomsTasksRepoType)
export class GetCustomsTasksRepo implements IGetCustomsTasksRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: any) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/customs_tasks', query) });

      if (result.status === 200) {
        const data: ICustomsTask[] = result.data.data.map((item) => CustomsTasksMapper.toDomain(item));
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: { data, total },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
